import { Component, enableProdMode, OnInit, HostListener, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl, FormArray } from '@angular/forms';
import { HttpClient, HttpHeaders} from '@angular/common/http';
import { environment } from './../environments/environment';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/map';


 enableProdMode();

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})


export class AppComponent implements OnInit {
  title = 'Tanker Wash Scheduler';
  form: FormGroup;
  filteredProducts1: Observable<string[]>;
  filteredProducts2: Observable<string[]>;
  filteredProducts3: Observable<string[]>;
  productSuggestions: string[] = [];
  showSuggestions1 = false;
  showSuggestions2 = false;
  showSuggestions3 = false;
  product1Message: { type: string, text: string };
  product2Message: { type: string, text: string };
  product3Message: { type: string, text: string };

  maxSuggestionsToShow = 10; // Limit the number of suggestions displayed
  restrictedProducts: string[] = [];
  approvedProducts: string[] = [];

  previousProduct1: FormControl = new FormControl();
  previousProduct2: FormControl = new FormControl();
  previousProduct3: FormControl = new FormControl();




  // Pagination
  pagination = 1;
  page = 0;
  hideRight;
  disableButton = 0;
  loaded = 0;
  submitting = 0;
  isMobile = false;
  error = 0;
  submitError = '';

  wash_types;
  dates;
  wash_accessorials;
  available_slots;
  business_hours;
  month = new Date();
  bay1;
  bay2;
  bay3;
  startTime = "";
  startDay = "";
  leftCursor = 0;
  rightCursor = 5;
  selectedWash;
  fileDocument;
  instanceURL;
  cta = [];

  // Extended booking window (PIN gate)
  extendedDays = 19;
  pinUnlocked = false;
  showPinModal = false;
  pinInput = '';
  pinError = '';
  pinLoading = false;


  // Form Data
  formAccessorials = [];
  formWashType = "";
  formWashTypeLabel = "";
  customFields = [];
  customFieldValues = {};

  // Scroll indicator
  showScrollIndicator = true;
  @ViewChild('additionalInfoSection') additionalInfoSection: ElementRef;

  // IMPORTANT: Slot size
  slot_size = 30;

  /*
   *
   * Main Intake Function
   *
   */
  selectWash (wash_type){

    // Label could be different if wash type is freehand.
    this.formWashType = wash_type;
    this.formWashTypeLabel = wash_type;
    this.selectedWash = wash_type;

    // Finalize selection based on list of wash types from server.
    var selected_wash = this.wash_types.find(function(element){
      return element.name === wash_type;
    });

    // Load custom fields for this wash type
    this.customFields = selected_wash.custom_fields || [];
    // Reset custom field values when changing wash type
    this.customFieldValues = {};

    // Wash Type Bays Eligible
    var eligible_bays = [];

    // Based on wash type, determine eligible bays
    selected_wash.bay_capable.forEach((item) => {
      eligible_bays.push(item.bay);
    });

    // Eligible Bay
     console.log(wash_type + " is eligible on the following bays: " + eligible_bays);

    // Clear out all available slots for lookup
    Object.keys(this.available_slots).forEach((day) =>{
      if(wash_type){
        this.available_slots[day] = this.getBayAvailability(eligible_bays, day, selected_wash.bay_capable);
      }
    });
  }

  /*
   *
   * Utility Functions
   *
   */

   // Iterate through business hours to obtain available slots
  getBayAvailability (bays, day, bay_durations){
    // List of available time slots to return
    var availableTimeSlots = [];
    var accessorial_duration = 0;
    // Add up duration for accessorials
     for (var indexAcc = 0; indexAcc < this.formAccessorials.length; indexAcc++){
       var accessorial_indx = this.formAccessorials[indexAcc];
       var selected_accessorial = this.wash_accessorials.find(function(element){
         return element.name === accessorial_indx;
       });

       if(selected_accessorial['duration'] > 0){
         accessorial_duration += parseInt(selected_accessorial['duration']);
       }
     }

    // Iterate through business hour slots to filter.
    this.business_hours[day].forEach((slot) =>{
        if(this.getBaySlotAvailability(bays,slot,day,bay_durations,accessorial_duration)){
          // Slot is available if at least bay is able to service wash duration
          availableTimeSlots.push(slot);
        }
    });
    return availableTimeSlots;
  }


  // Based on Bay, determine if slot is available for selected duration.
  getBaySlotAvailability (bays, slot, day, bay_durations,accessorial_duration) {
    var isAvailable = false;

    for(var index = 0; index < bays.length; index++){
      var times = this.getBayTimes(bays[index])[day];
      var duration = 0;

      // find duration/number of slots
      for(var loop = 0; loop < bay_durations.length; loop++){
        if(bay_durations[loop].bay == bays[index]){
            duration = parseInt(bay_durations[loop].duration);
        }
      }

      var numberOfSlots = Math.ceil((duration+accessorial_duration)/this.slot_size);

      // Determine if slot is available and has enough time to complete wash
      // TODO: rework logic to go off next day availability for more available slots
      if(times && times.indexOf(slot) > -1 ){
        if(numberOfSlots === 1){
          isAvailable = true;
        }
        else{
          isAvailable = true;
          // do some logic here for subsequent slots
          var dat = new Date(parseInt(day.substring(6,10),10),parseInt(day.substring(0,2),10)-1,parseInt(day.substring(3,5),10),parseInt(slot.substring(0,2),10),parseInt(slot.substring(3,5),10));
          for( var i = 1; i <= numberOfSlots-1; i++){

            // constructing a new date based on slot size.
             var verify_date = new Date(dat.getTime() + this.slot_size*i*60000);

            // If subsequent slots are unavailable don't allow booking.
            if (dat.getDay() != verify_date.getDay()){
              isAvailable = false;
            }

            // Set to false if time isn't available.
             if(times.indexOf( (verify_date.getHours() < 10 ? "0"+verify_date.getHours(): verify_date.getHours())+":"+(verify_date.getMinutes() < 10 ? "0"+verify_date.getMinutes(): verify_date.getMinutes()) ) < 0){
                isAvailable = false;
             }
          }
        }
      }
    }

    return isAvailable;
  }

  // Bay times determined based on server result
  getBayTimes(bay){
    var bayValue = {};
    if(bay == '1')
      bayValue = this.bay1;
    if(bay == '2')
      bayValue = this.bay2;
    if(bay == '3')
      bayValue = this.bay3;
    return bayValue;
  }



  /*
   *
   * User Interface Functions
   *
   */

  // Set function based on wash label field for wash type: Other
  setWashLabel(wash_type_label){
    this.formWashTypeLabel = this.form.value.wash_type_label;
  }

  // Displays eligible slots
  getDaySlots (day){
    var indx = Object.keys(this.available_slots).indexOf(day);
    return this.available_slots[Object.keys(this.available_slots)[indx]];
  }

  // Display Twelve Hour Format
  TwelveHourFormat(time) {
    if(!time) return "";
    var dtParts = time.split(":");

    var hours = dtParts[0];
    var minutes = dtParts[1];
    var suffix = "AM";

    if (hours > 12) {
        hours = hours - 12;
        suffix = "PM";
    }
    else if (hours == "00") {
        hours = 12;
        suffix = "AM";
    }
    else if (hours == "12") {
        suffix = "PM";
    }

    return (hours + ":" + minutes + " " + suffix);
  }

  /* Assign Slot */
  assignTime(day, slot){
    this.startTime = slot;
    this.startDay = day;
  }

  /* Move Left */
  moveLeft(){
    if(this.leftCursor > 0){
      this.leftCursor-=5;
      this.rightCursor-=5;
    }
  }

  onFileSelect(event) {
     if (event.target.files.length > 0) {
       const file = event.target.files[0];
       this.fileDocument = file;
     }
   }

  /* Move Left */
  submit(form){

    form.startDay = this.startDay;
    form.startTime = this.startTime;

    form.wash_accessorials = this.formAccessorials;
    form.wash_type = this.formWashType;
    form.wash_type_label = this.formWashTypeLabel;
    form.additionalEmails = this.additionalEmailsList.filter(email => email.trim() !== '');
    form.custom_fields = this.customFieldValues;

    var formData = new FormData();
    formData.append('file', this.fileDocument);
    formData.append('form', JSON.stringify(form));

    this.disableButton = 1;
    this.submitting = 1;

    this.submitError = '';
    this.httpClient.post(environment.API_URL+'/api/submit',formData).subscribe(
      (res)=>{
        this.submitting = 0;
        if('error' in res)
        {
          this.page = 2;
          this.reloadTimes();
        }else{
          this.page++;
        }
        console.log(res);
      },
      (error) => {
        this.submitting = 0;
        this.disableButton = 0;
        if (error.error && error.error.error) {
          this.submitError = error.error.error;
        } else {
          this.submitError = 'An unexpected error occurred while processing your booking.';
        }
        console.error('Submit error:', error);
      }
    );
  }


  /* Move Right — requires PIN when stepping into extended days */
  moveRight(){
    if (this.rightCursor < this.dates.length) {
      // Still within currently loaded dates — navigate normally
      this.leftCursor += 5;
      this.rightCursor += 5;
    } else if (!this.pinUnlocked) {
      // At the edge of standard days — prompt for PIN to load extended days
      this.showPinModal = true;
      this.pinInput = '';
      this.pinError = '';
    }
  }

  submitPin(){
    if (this.pinInput.length !== 4) {
      this.pinError = 'Please enter a 4-digit code.';
      return;
    }
    this.pinLoading = true;
    this.pinError = '';
    const timestamp = Date.now();
    this.httpClient.get<any>(
      `${environment.API_URL}/api/data?timestamp=${timestamp}&days=${this.extendedDays}&pin=${this.pinInput}`
    ).subscribe(
      (res) => {
        this.pinLoading = false;
        this.pinUnlocked = true;
        this.showPinModal = false;
        // Merge extended data into existing state
        this.dates = res.get_dates;
        this.business_hours = JSON.parse(JSON.stringify(res.business_hours));
        // Rebuild available slots for the full window using the current wash selection
        const newSlots = JSON.parse(JSON.stringify(res.business_hours));
        Object.keys(newSlots).forEach(day => { newSlots[day] = []; });
        this.available_slots = newSlots;
        this.bay1 = res.bay1;
        this.bay2 = res.bay2;
        this.bay3 = res.bay3;
        if (this.selectedWash) this.selectWash(this.selectedWash);
        // Now actually move right
        this.leftCursor += 5;
        this.rightCursor += 5;
      },
      (error) => {
        this.pinLoading = false;
        if (error.status === 403) {
          this.pinError = 'Incorrect code. Please try again.';
        } else {
          this.pinError = 'Something went wrong. Please try again.';
        }
      }
    );
  }

  closePinModal(){
    this.showPinModal = false;
    this.pinInput = '';
    this.pinError = '';
  }

  checkRestrictedProduct (){
    if(this.form.value.previousProduct1 && this.restrictedProducts.includes(this.form.value.previousProduct1.toLowerCase())
               || (this.form.value.previousProduct2 && this.restrictedProducts.includes(this.form.value.previousProduct2.toLowerCase()))
               || (this.form.value.previousProduct3 && this.restrictedProducts.includes(this.form.value.previousProduct3.toLowerCase()))
      )
          return 1;
      return 0;
  }

  checkRequiredFormFields(){
    if (this.formWashType == "" ||
    this.form.value.companyName == "" ||
    this.form.value.contactName == "" ||
    this.form.value.email == "" ||
    this.form.value.phoneNumber == "" ||
    this.form.value.trailerNumber == "" ||
    this.form.value.previousProduct1 == ""  ||
    this.startDay == "" ||
    this.startTime == "" ||
    this.form.value.previousProduct1 == null ||
    this.form.controls.email.invalid ||
      (this.previousThreeRequired(this.formWashType)
        &&  (this.form.value.previousProduct2 == ""
             || this.form.value.previousProduct2 == null
             || this.form.value.previousProduct3 == ""
             || this.form.value.previousProduct3 == null
            ))){
        return 1;
    }else{
        return 0;
    }
  }

  checkSummaryPageFields(){
    return this.checkRequiredFormFields() || !this.checkRequiredCustomFields() ? 1 : 0;
  }

  previousThreeRequired(wash_type){
    if(wash_type == "JPA Type II" ||
       wash_type == "JPA Type III" ||
       wash_type == "JPA Type V" ||
       wash_type == "Kosher Upgrade" ||
       wash_type == "Passivation" ||
       wash_type == "Simple Kosher" ||
       wash_type == "Sucrose Wash" || 
       wash_type == "CARGILL OIL KOSHER WASH"){
      return 1;
    }else{
      return 0;
    }
  }

  /* PAGINATION */
  nextPage(){
    this.hideRight = this.checkRequiredFormFields();
    if(this.page < 4)
      this.page++;

    if(this.page == 1 && !this.isMobile)
      this.page++;

    // Reset scroll indicator when entering summary page
    if(this.page == 4 && this.customFields.length > 0) {
      this.showScrollIndicator = true;
      window.scrollTo(0, 0);
    }
  }

  previousPage(){
    if(this.page > 0)
      this.page--;

    if(this.page == 1 && !this.isMobile)
      this.page--;
  }
  formatDate (date){
    var year = date[6] + date[7] + date[8] + date[9];
    var month = date[0] + date[1];
    var day = date[3] + date[4];
    var dateString = year + '-' + month + '-' + day + 'T08:00:00';
    return new Date(dateString);
  }

  checkForm(){
    this.hideRight = this.checkRequiredFormFields();
  }

  /* Mimic checkbox in Angular */
  selectAccessorial(index,accesorial){
    // Check if the form value is empty
    if(this.formAccessorials.indexOf(accesorial) == -1)
      this.formAccessorials.push(accesorial);
    else{
      // Swap last element to current position, then pop value.
      this.formAccessorials[this.formAccessorials.indexOf(accesorial)] = this.formAccessorials[this.formAccessorials.length-1];
      this.formAccessorials.pop();
    }
    if(this.selectedWash){
      this.selectWash(this.selectedWash);
    }
  }

  reloadPage(){
    window.location.reload();
  }

  turnOffCTA(){
    this.cta["cta_active"] = false;
  }


  reloadTimes(){
    this.loaded = 0;
    this.error = 1;
    this.httpClient.get<any>(environment.API_URL+'/api/data/').subscribe((res)=>{
      this.dates = res.get_dates;
      this.bay1 = res.bay1;
      this.bay2 = res.bay2;
      this.bay3 = res.bay3;
      this.loaded = 1;
      this.selectWash(this.selectedWash);
      this.disableButton = 0;
      this.restrictedProducts = res.products.restricted.map(function(x){ return x.toLowerCase(); });
      this.approvedProducts = res.products.approved.map(function(x){ return x.toLowerCase(); });;
      this.productSuggestions = [...res.products.approved, ...res.products.restricted];
    });
  }

  constructor(fb: FormBuilder, private httpClient: HttpClient, private deviceService: DeviceDetectorService,private route: ActivatedRoute, private router: Router) {
      // Pagination
      this.pagination = 1;
      this.page = 0;
      this.hideRight = 0;

      this.isMobile = this.deviceService.isMobile();

      // get all info
      var timestamp = Date.now();
      this.httpClient.get<any>(environment.API_URL+'/api/data?timestamp='+timestamp).subscribe((res)=>{
        this.dates = res.get_dates;
        this.wash_types = res.wash_types;
        this.wash_accessorials = res.wash_accessorials;
        this.available_slots = JSON.parse(JSON.stringify(res.business_hours));
        this.business_hours = JSON.parse(JSON.stringify(res.business_hours));
        this.bay1 = res.bay1;
        this.bay2 = res.bay2;
        this.bay3 = res.bay3;
        this.loaded = 1;
        this.instanceURL = res.instanceURL;
        this.restrictedProducts = res.products.restricted.map(function(x){ return x.toLowerCase(); });;
        this.approvedProducts = res.products.approved.map(function(x){ return x.toLowerCase(); });;
        this.productSuggestions = [...res.products.approved, ...res.products.restricted];
        this.cta = res.cta;
        this.cta["cta_body"] = atob(this.cta["cta_body"]);
        if (res.extended_days) this.extendedDays = res.extended_days;
      });

      this.form = fb.group ({
        // wash_type: ['', Validators.required],
        wash_type_label: ['', Validators.required],
        // wash_accessorials: ['', Validators.required],
        companyName: ['', Validators.required],
        contactName: ['', Validators.required],
        email: ['', [Validators.required,  Validators.email]],
        phoneNumber: ['', Validators.required],
        poNumber: ['', Validators.required],
        trailerNumber: ['', Validators.required],
        previousProduct1: this.previousProduct1,
        previousProduct2: this.previousProduct2,
        previousProduct3: this.previousProduct3,
        notes: ['', Validators.required],
        file: null,


      });
  }

  ngOnInit() {

    // Check if "page" parameter exists in the URL
    this.route.queryParams.subscribe((params) => {
      if (params['page']) {
        this.page = +params['page']; // Convert "page" to a number and assign it to this.page
      }
    });
    this.filteredProducts1 = this.previousProduct1.valueChanges
    .startWith('')
    .map(value => this.filter(value));

    this.filteredProducts2 = this.previousProduct2.valueChanges
      .startWith('')
      .map(value => this.filter(value));

    this.filteredProducts3 = this.previousProduct3.valueChanges
      .startWith('')
      .map(value => this.filter(value));

    
  }

  private filter(value: string): string[] {
    const filterValue = (value || '').toLowerCase(); // Check for null or undefined
    return this.productSuggestions.filter(option => option.toLowerCase().includes(filterValue)).slice(0, this.maxSuggestionsToShow);
  }

  onProductSelected(control: FormControl, value: string, suggestionIndex: number) {
    this.validateProduct(value, suggestionIndex);
    control.setValue(value);
    this.hideSuggestions(suggestionIndex);
  }

  onProductBlur(control: FormControl, suggestionIndex: number) {
    const value = control.value;
    this.validateProduct(value, suggestionIndex);
  }

  validateProduct(value: string, suggestionIndex: number) {
    if (!value) {
      this.clearMessage(suggestionIndex);
      return;
    }

    const lowerValue = value.toLowerCase();
    if (this.restrictedProducts.includes(lowerValue)) {
      this.setMessage(suggestionIndex, 'error', `${value} is listed as prohibited product by the City of Stockton and cannot be cleaned at our facility.`);
    } else if (this.approvedProducts.includes(lowerValue)) {
      this.setMessage(suggestionIndex, 'approved', `${value} is an approved product.`);
    } else {
      this.setMessage(suggestionIndex, 'warning', `Unable to find ${value}. Please note non-edible previous products not listed will require staff approval.`);
    }
  }

  setMessage(suggestionIndex: number, type: string, text: string) {
    const message = { type, text };
    if (suggestionIndex === 1) {
      this.product1Message = message;
    } else if (suggestionIndex === 2) {
      this.product2Message = message;
    } else if (suggestionIndex === 3) {
      this.product3Message = message;
    }
  }

  clearMessage(suggestionIndex: number) {
    if (suggestionIndex === 1) {
      this.product1Message = null;
    } else if (suggestionIndex === 2) {
      this.product2Message = null;
    } else if (suggestionIndex === 3) {
      this.product3Message = null;
    }
  }

  hideSuggestions(suggestionIndex: number) {
    setTimeout(() => {
      if (suggestionIndex === 1) {
        this.showSuggestions1 = false;
      } else if (suggestionIndex === 2) {
        this.showSuggestions2 = false;
      } else if (suggestionIndex === 3) {
        this.showSuggestions3 = false;
      }
    }, 200); // Delay to allow click event to register
  }

  showSuggestions(suggestionIndex: number) {
    if (suggestionIndex === 1) {
      this.showSuggestions1 = true;
    } else if (suggestionIndex === 2) {
      this.showSuggestions2 = true;
    } else if (suggestionIndex === 3) {
      this.showSuggestions3 = true;
    }
  }

  additionalEmailsList: string[] = [];

  addAdditionalEmail() {
    this.additionalEmailsList.push('');
  }

  removeAdditionalEmail(index: number) {
    this.additionalEmailsList.splice(index, 1);
  }

  updateAdditionalEmail(index: number, value: string) {
    this.additionalEmailsList[index] = value;
  }

  trackByIndex(index: number): number {
    return index;
  }

  updateCustomFieldValue(fieldName: string, value: any) {
    this.customFieldValues[fieldName] = value;
    this.checkForm();
  }

  updateCustomFieldCheckbox(fieldName: string, event: any) {
    this.customFieldValues[fieldName] = event.target.checked;
    this.checkForm();
  }

  checkRequiredCustomFields(): boolean {
    for (let field of this.customFields) {
      if (field.required) {
        const value = this.customFieldValues[field.name];
        // For checkboxes, must be explicitly true (checked)
        if (field.type === 'checkbox') {
          if (value !== true) {
            return false;
          }
        } else {
          // For other fields, check if value exists
          if (value === undefined || value === null || value === '') {
            return false;
          }
        }
      }
    }
    return true;
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    // Hide scroll indicator once user scrolls down
    if (window.scrollY > 100) {
      this.showScrollIndicator = false;
    }
  }

  scrollToAdditionalInfo() {
    if (this.additionalInfoSection) {
      this.additionalInfoSection.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      this.showScrollIndicator = false;
    }
  }
}



// WEBPACK FOOTER //
// /opt/atlassian/pipelines/agent/build/src/app/app.component.ts